import React from 'react';
import classNames from 'classnames';

import MinimalNav from '../MinimalNav';
import Evelyn from '../Evelyn';
import StepNavigator from '../StepNavigator';
import LoaderComponent from '@evdy/web-core/dist/components/shared/elements/LoaderComponent';

import { useHideIntercom, useGetPreneedPackages } from '../../customHooks';

import styles from './StepContainer.module.scss';

const {
  'step-container': stepContainerClass,
  'hidden-nav': hiddenNavClass,
  'purchase-nav': purchaseNavClass,
  'purchase-step': purchaseStepClass,
  evelyn: evelynClass
} = styles;

const StepContainer = ({
  children,
  evelynArray,
  hideNav = false,
  navCopy,
  showLoader = false,
  location
}) => {
  // hide intercom
  useHideIntercom();
  // get preneed packages
  useGetPreneedPackages();

  const stepContainerClasses = classNames(stepContainerClass, {
    [hiddenNavClass]: hideNav
  });

  const purchaseStepClasses = classNames(purchaseStepClass, 'purchase-step-content'); // set global class for use with react lazy-load to detect scroll

  return (
    <div className={stepContainerClasses}>
      <MinimalNav pageCopy={navCopy} {...{ location }} />
      <div className={purchaseNavClass}>
        <StepNavigator />
      </div>
      <div className={purchaseStepClasses}>
        <Evelyn customClass={evelynClass} speechBubbleArray={evelynArray} />
        {children}
      </div>
      {showLoader && <LoaderComponent />}
    </div>
  );
};

export default StepContainer;
